import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../lib/api';

interface Stats {
  sources: number;
  messages: number;
  users: number;
  jobsQueued: number;
  telegramConfigured: boolean;
  telegramAuthorized: boolean;
}

export function DashboardPage() {
  const [stats, setStats] = useState<Stats | null>(null);

  useEffect(() => {
    void api.get<Stats>('/api/meta/stats').then(setStats);
  }, []);

  return (
    <div>
      <h1>Overzicht</h1>
      <p className="page-lead">
        Gedeelde OSINT-werkruimte. Inladen en Telegram-calls lopen via achtergrondjobs.
      </p>

      <div className="grid-stats">
        <div className="stat">
          <div className="label">Bronnen</div>
          <div className="value">{stats?.sources ?? '—'}</div>
        </div>
        <div className="stat">
          <div className="label">Berichten</div>
          <div className="value">{stats?.messages ?? '—'}</div>
        </div>
        <div className="stat">
          <div className="label">Gebruikers</div>
          <div className="value">{stats?.users ?? '—'}</div>
        </div>
        <div className="stat">
          <div className="label">Actieve jobs</div>
          <div className="value">{stats?.jobsQueued ?? '—'}</div>
        </div>
      </div>

      <div className="panel">
        <div className="row">
          <strong>Telegram</strong>
          <span className={`badge ${stats?.telegramAuthorized ? 'ok' : stats?.telegramConfigured ? 'warn' : 'danger'}`}>
            {stats?.telegramAuthorized
              ? 'ingelogd'
              : stats?.telegramConfigured
                ? 'nog niet ingelogd'
                : 'API-gegevens ontbreken'}
          </span>
        </div>
        <p className="muted" style={{ marginBottom: 0 }}>
          {stats?.telegramAuthorized
            ? 'Snel starten: ontdek kanalen, sla bronnen op, laad in op de achtergrond.'
            : 'Log als beheerder in via Telegram in het menu, daarna kun je kanalen inladen.'}
        </p>
        <div className="row" style={{ marginTop: 14 }}>
          {!stats?.telegramAuthorized && (
            <Link className="btn btn-sm" to="/telegram">
              Telegram koppelen
            </Link>
          )}
          <Link className="btn btn-ghost btn-sm" to="/discover">
            Ontdekken
          </Link>
          <Link className="btn btn-ghost btn-sm" to="/ingest">
            Inladen
          </Link>
          <Link className="btn btn-ghost btn-sm" to="/search">
            Zoeken
          </Link>
        </div>
      </div>
    </div>
  );
}
